import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ProductViewComponentDef } from '@df/catalog-ui/product/view/product-view.component.def';
import { IProductDataV3 } from '@df/catalog/product/product';
import { Product } from '../../product/product.decorator';
import { ProductViewLayoutComponent } from '../view-layout/product-view-layout.component';
@Component({
    selector: 'product-view',
    template: '<cms-product-view-layout [variant]="model.ppLayoutVariant" ></cms-product-view-layout>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [forwardRef(() => ProductViewLayoutComponent)]
})
export class ProductViewComponent extends ProductViewComponentDef<Product<IProductDataV3>> {
}
